import ApiService from './ApiService';

export default class LocationApi extends ApiService {
    constructor() {
        super('system');
    }

    getLocations(payload) {
        return this.get('locations', payload);
    }

    getLocationById(locationId) {
        return this.get(`locations/${locationId}`);
    }

    createLocation(payload) {
        return this.post('locations', payload);
    }

    editLocation(data) {
        const { locationId, payload } = data;
        return this.put(`locations/${locationId}`, payload);
    }

    deleteLocation(locationId) {
        return this.delete(`locations/${locationId}`);
    }

    // for bike
    getLocationsByBike(payload) {
        const { bikeId, ...rest } = payload;
        return this.get(`locations/bikes/${bikeId}`, rest);
    }

    getPricesCombobox(payload) {
        return this.get('prices/cbx/all', payload);
    }

    // #region Bike list
    getBikeByLocation(payload) {
        const { locationId, ...rest } = payload;
        return this.get(`bikes/locations/${locationId}`, rest);
    }

    registerBike(payload) {
        return this.post('bikes/register/locations', payload);
    }

    unregisterBike(payload) {
        return this.post('bikes/unregister/locations', payload);
    }
    // #endregion
}
